<template>
  <div class="mapwrapper">
    <div class="map">
      <MglMap
        :accessToken="accessToken"
        :mapStyle.sync="mapStyle"
        :center="newCoordinate"
        :zoom="zoom"
      >
        <MglMarker
          :coordinates.sync="newCoordinate"
          draggable
          @dragend="stateLocation(newCoordinate)"
        >
          <span slot="marker" class="mapboxgl-marker">
            <img src="@/assets/marker.png" alt="" />
          </span>
        </MglMarker>

        <MglAttributionControl />
        <MglNavigationControl position="top-right" />
      </MglMap>

      <div class="btns-info">
        <span class="btn" @click="loadGPS()">{{ statusText }}</span>
        <span class="info"
          >Please Drag the Marker to Pin your desired Location.</span
        >
      </div>
      <!-- eo btns-panel -->
    </div>
    <!-- eo map -->
  </div>
</template>

<script>
import {
  MglMap,
  MglMarker,
  MglAttributionControl,
  MglNavigationControl,
  MglGeolocateControl,
  MglFullscreenControl,
  MglScaleControl,
} from "vue-mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CheckoutMap",
  components: {
    MglMap,
    MglMarker,
    MglNavigationControl,
    MglAttributionControl,
    MglScaleControl,
    MglGeolocateControl,
  },
  data() {
    return {
      defaultcoord: [85.315245, 27.7068482],
      newCoordinate: [85.315245, 27.7068482],
      statusText: "Loading GPS",
      isMapLoaded: 0,
      accessToken:
        "pk.eyJ1Ijoia2hhYW5waW4iLCJhIjoiY2p5ZXI5c2FwMDNsMzNobzdkaWgyNnB1MSJ9.VJFEMcSTKXmER7VTW_p4Fg",
      mapStyle: "mapbox://styles/mapbox/light-v9",
      zoom: 17,
    };
  },
  created() {
    this.loadGPS();
  },
  methods: {
    ...mapActions(["markerChange"]),

    stateLocation: function (coord) {
      if (
        this.defaultcoord[0] == coord[1] ||
        this.defaultcoord[1] == coord[0]
      ) {
        this.$message.warning(
          "Some Issue With Location, Please Enable GPS or Select a location in Map"
        );
      } else {
        let a = [coord[1], coord[0]];
        this.markerChange(a);
      }
    },

    loadGPS: function () {
      // console.log('here')

      this.statusText = "Accessing GPS...";

      navigator.geolocation.getCurrentPosition((position) => {
        this.newCoordinate = [
          Number(position.coords.longitude),
          Number(position.coords.latitude),
        ];

        this.statusText = "Pin My Current Location";

        this.stateLocation(this.newCoordinate);
      });
    },
  },

  computed: {
    ...mapGetters(["locationMarker"]),
  },
};
</script>
<style lang="scss" scoped>
.map {
  width: 400px;
  height: 400px;
}

.mapboxgl-marker {
  display: block;
  // width: 10px;
  // height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
  // background: rgb(255, 85, 85);
  // border-radius: 20px;
  transform: translate(0, -100%);
}

.btns-info {
  position: relative;
  z-index: 999;
  top: -40px;
  background: #000000d1;
  padding: 5px;
  overflow: hidden;

  .btn {
    cursor: pointer;
    display: inline-block;
    background: rgb(91, 148, 0);
    padding: 7px;
    border: 3px solid #ccc;
    color: #fff;
    border-radius: 11px;
    text-transform: uppercase;
    font-weight: bold;
    float: left;
  }

  .info {
    float: left;
    margin-left: 10px;
    text-align: left;
    color: #fff;
    width: 50%;
  }
}
</style>